import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M-6,-0.5h1v0.5h-1zM5.5,-0.5h0.5v0.5h-0.5zM-6,0h1.5v0.5h-1.5zM4.5,0h1.5v0.5h-1.5zM-6,0.5h2v0.5h-2zM4,0.5h2v0.5h-2zM-6,1h3v0.5h-3zM3,1h3v0.5h-3zM-3,1.5h7v0.5h-7zM-3.5,2h7.5v0.5h-7.5zM-1,2.5h3.5v0.5h-3.5z',
    },
    {
      paint: 'rock',
      d: 'M-2.5,-3h1.5v0.5h-1.5zM-5,-2.5h1.5v0.5h-1.5zM-3,-2.5h4v0.5h-4zM3,-2.5h0.5v0.5h-0.5zM4,-2.5h0.5v0.5h-0.5zM-5.5,-2h10.5v0.5h-10.5zM-6,-1.5h1v1h-1zM-4.5,-1.5h1v0.5h-1zM-1.5,-1.5h4.5v0.5h-4.5zM3.5,-1.5h2v0.5h-2zM4.5,-1h0.5v1h-0.5zM5.5,-1h0.5v0.5h-0.5zM-5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'water',
      d: 'M-3.5,-1.5h2v0.5h-2zM3,-1.5h0.5v0.5h-0.5zM-4.5,-1h9v0.5h-9zM-4.5,-0.5h1v0.5h-1zM-0.5,-0.5h3.5v0.5h-3.5zM4,-0.5h0.5v0.5h-0.5zM-4.5,0h1.5v0.5h-1.5zM3.5,0h1v0.5h-1zM-4,0.5h2v0.5h-2zM3,0.5h1v0.5h-1zM-3,1h2.5v0.5h-2.5zM1.5,1h1.5v0.5h-1.5z',
    },
    {
      paint: 'epicPortal',
      d: 'M-4,-3.5h1.5v1h-1.5zM3,-3.5h1v0.5h-1zM2.5,-3h2v0.5h-2zM-5,-1.5h0.5v0.5h-0.5zM5,-1h0.5v0.5h-0.5zM-3.5,-0.5h3v0.5h-3zM3,-0.5h1v0.5h-1zM-3,0h1v0.5h-1zM-1.5,0h3.5v0.5h-3.5zM2.5,0h1v0.5h-1zM-2,0.5h2v0.5h-2zM0.5,0.5h2.5v0.5h-2.5zM-0.5,1h2v0.5h-2z',
    },
    {
      paint: 'epicCrystal',
      d: 'M-3.5,-2.5h0.5v0.5h-0.5zM3.5,-2.5h0.5v0.5h-0.5zM-5,-1h0.5v0.5h-0.5zM5,-0.5h0.5v0.5h-0.5zM-2,0h0.5v0.5h-0.5zM2,0h0.5v0.5h-0.5zM0,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'moss', d: 'M-5,1.5h2v0.5h-2zM4,1.5h1.5v0.5h-1.5zM4.5,2h0.5v0.5h-0.5z' },
  ],
  pixels: 238,
};
export const sprites: readonly PixelSprite[] = [variant0];
